import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Link,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  const handlePrivacyPolicy = () => {
    navigate('/privacy');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: 1000,
        p: 3,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6" gutterBottom>
          🍪 Cookie Notice
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
          We use cookies to enhance your browsing experience, serve personalized content, 
          and analyze our traffic. By clicking "Accept All", you consent to our use of cookies. 
          You can learn more about our cookie policy in our{' '}
          <Link
            component="button"
            variant="body2"
            onClick={handlePrivacyPolicy}
            sx={{ textDecoration: 'none' }}
          >
            Privacy Policy
          </Link>
          .
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAccept}
            size="small"
          >
            Accept All
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDecline}
            size="small"
          >
            Decline
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CookieBanner;
